import angular from 'angular';
import Routes from './settings.routes';
import ConfigurationComponent from './configuration/configuration.component';

export default angular.module('autoboard.settings', [ConfigurationComponent])
  .config(Routes)
  .name;
